import { Component, Signal } from '@angular/core';
import { IGlobalElements } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/interfaces/global-elements.interface';
import { GlobalElementsService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/global-elements.service';

@Component({
  standalone: false,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent {
  globalElements: Signal<IGlobalElements>;

  constructor(private readonly globalEmentsService: GlobalElementsService) {}

  ngOnInit() {
    this.globalElements = this.globalEmentsService.globalElements;
  }
}
